import { useEffect } from "react";


const CSS = `
  #vlibras-container {
    display: block !important;
    position: fixed !important;
    z-index: 2147483647 !important;
    bottom: 24px !important;
    left: 24px !important;
  }
`;

const VLibras = () => {
  useEffect(() => {
    // CSS
    const style = document.createElement("style");
    style.id = "vlibras-css";
    style.textContent = CSS;
    document.head.appendChild(style);

    // DOM
    const container = document.createElement("div");
    container.id = "vlibras-container";
    container.setAttribute("vw", "main");

    const btn = document.createElement("div");
    btn.setAttribute("vw-access-button", "");
    btn.classList.add("active");
    container.appendChild(btn);

    const wrapper = document.createElement("div");
    wrapper.setAttribute("vw-plugin-wrapper", "");
    wrapper.appendChild(Object.assign(document.createElement("div"), { className: "vw-plugin-top-wrapper" }));
    container.appendChild(wrapper);

    document.body.appendChild(container);

    // Script
    const init = () => {
      try { new window.VLibras.Widget("https://vlibras.gov.br/app"); } catch (_) {}
    };

    if (window.VLibras) {
      init();
    } else {
      const script = document.createElement("script");
      script.id = "vlibras-script";
      script.src = "https://vlibras.gov.br/app/vlibras-plugin.js";
      script.onload = init;
      document.body.appendChild(script);
    }

    return () => {
      var c = document.getElementById("vlibras-container");
      if (c) c.remove();
      var s = document.getElementById("vlibras-css");
      if (s) s.remove();
    };
  }, []);

  return null;
};

export default VLibras;
